import React, {Fragment, useCallback, useEffect, useState} from "react";
import {Button, Container, Grid2, TextField, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import TextAreaEditor from "components/common/TextAreaEditor";
import {ACTION_STATES} from "core/actions";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {formStyles} from "./formStyles";
import {actions} from "./logic/actions";
import {assertString} from "core/validation";

const useStyle = makeStyles(formStyles);

const SettingsTemplateForm = (props) => {
    const { editing, handleClose, changeForm, saveTemplate, clear, template } = props;

    const classes = useStyle();

    const [name, setName] = useState(props.name);
    const [value] = useState(props.value);
    const valueRef = React.useRef();
    const [errors, setErrors] = useState(null);

    let saved = props.savingTemplate === ACTION_STATES.SUCCESS;

    useEffect(() => {
        if (editing) {
            changeForm({ attribute: "id", value: props.id });
            changeForm({ attribute: "name", value: props.name });
            changeForm({ attribute: "instructionValue", value: props.value });
        }
        return () => changeForm({ attribute: "id", value: null });
    }, [changeForm, editing, props.id, props.name, props.value]);

    useEffect(() => {
        if (saved) {
            clear();
            handleClose();
        }
    }, [clear, handleClose, saved]);

    const handleChangeName = useCallback((e) => {
        const value = e.target.value;
        if(errors?.name) {
            setErrors({
                ...errors,
                name:assertString(value) ? null: "Required"
            });
        }
        setName(e.target.value);
    }, [errors]);

















    function handleSave() {

        const errors = {};
        const value = getTemplate();
        if(!assertString(value.name)) {
            errors.name = "Required";
        }
        if(!assertString(value.instructionValue)) {
            errors.template = "Required";
        }
        setErrors(errors);
        if(Object.keys(errors).length === 0) {
            saveTemplate(value);
        }

    }

    function getTemplate() {
        return {
            instructionValue: valueRef.current.getValue(),
            name: name,
            id: template ? template.id : null,
        };
    }

    function onChangeText() {
        if(!!errors?.template && assertString(valueRef.current.getValue())) {
            setErrors({
                ...errors,
                template:null
            });
        }
    }





    return (
        (<Fragment>
            <Container maxWidth="lg" component="form" className={classes.formMain}>
                <Grid2 padding={2} container size={12} columnSpacing={8}>
                    <Grid2 size={4} justify="center" alignItems="center" wrap="nowrap">
                        <Grid2
                            size={{
                                md: 1,
                                xs: 2
                            }}>
                            <Typography>Name</Typography>
                        </Grid2>
                        <Grid2
                            size={{
                                md: 11,
                                xs: 10
                            }}>
                            <TextField
                                value={name}
                                error={!!errors?.name}
                                onChange={handleChangeName}
                                variant="outlined" />
                            {errors?.name && <label className={"textError"}>{errors.name}</label>}
                        </Grid2>
                    </Grid2>
                    <Grid2 size={8}>
                        <Grid2
                            size={{
                                md: 1,
                                xs: 2
                            }}>
                            <Typography>Instruction</Typography>
                        </Grid2>
                        <Grid2
                            size={{
                                md: 11,
                                xs: 10
                            }}>
                            <TextAreaEditor
                                ref={valueRef}
                                onChangeText={onChangeText}
                                error={!!errors?.template}
                                rootStyle={{ width: "100%", maxWidth: "100%" }}
                                defaultValue={value}
                            />
                            {errors?.template && <label className={"textError"}>{errors.template}</label>}
                        </Grid2>
                    </Grid2>
                </Grid2>
                <Grid2 container justify="flex-end" alignItems="flex-end" style={{ marginTop: 50 }}>
                    <Button onClick={handleSave} color="secondary" variant="contained">
                        Save
                    </Button>
                </Grid2>
            </Container>
        </Fragment>)
    );
};

SettingsTemplateForm.propTypes = {
    handleClose: PropTypes.func.isRequired,
    name: PropTypes.string,
    value: PropTypes.string,
    editing: PropTypes.bool,
    id: PropTypes.string,
    changeForm: PropTypes.func,
    saveTemplate: PropTypes.func,
    clear: PropTypes.func,
    template: PropTypes.object,
    savingTemplate: PropTypes.string,
};

const mapStateToProps = ({ templateSettings }) => ({
    template: templateSettings.templateForm,
    savingTemplate: templateSettings.savingTemplate,
});

const mapDispatchToProps = (dispatch) => {
    return {
        changeForm: (payload) => dispatch(actions.CHANGE_TEMPLATE_FORM.call(payload)),
        saveTemplate: (template) => dispatch(actions.SAVE_TEMPLATE.send(template)),

        clear: () => dispatch(actions.CLEAR.call()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTemplateForm);
